<template>
  <base-icon
    icon="cog"
    :action="goTo"
    title="設定"
  />
</template>

<script>
import BaseIcon from './Base'

export default {
  components: {
    BaseIcon
  },

  methods: {
    goTo () {
      this.$router.push({ name: 'user-info' })
    }
  }
}
</script>
